export default __webpack_public_path__ + "static/media/c_2.a0c017e0.JPG";